module.exports = do ->
   return [
      {value: "1and6", label: "1's and 6's"}
      {value: "2and7", label: "2's and 7's"}
      {value: "3and8", label: "3's and 8's"}
      {value: "4and9", label: "4's and 9's"}
      {value: "0and5", label: "5's and 0's"}
   ]
